<template>
    <v-form ref="form_documentos">
        <v-container fluid grid-list-md v-if="_.size(this.listArchivos) > 0">
            <v-row dense>
                <v-col cols="12">
                     <v-list two-line subheader>
                        <v-subheader inset>
                            <span>Documentos</span>
                            <span class="ml-2" v-html="`(Tamaño Max. ${(this.parametros.taMaxArchivo/this.numDividir)} MB)`"></span>                            
                        </v-subheader>

                        <v-list-item
                            v-for="item in listArchivos"
                            :key="item.title"
                        >
                            <v-list-item-avatar>
                                <v-icon
                                    :class="[item.iconClass]"
                                    v-text="item.icon"
                                ></v-icon>
                            </v-list-item-avatar>

                            <v-list-item-content>
                                <v-list-item-title v-text="item.title"></v-list-item-title>
                                <v-list-item-subtitle v-text="item.subtitle"></v-list-item-subtitle>
                                <v-text-field style="display: none;"
                                :rules="_.size(listArchivos) > totalFiles ? requeridoRegla : []"></v-text-field>
                            </v-list-item-content>

                            <v-list-item-action>
                            <v-btn icon>
                                <v-tooltip top color="primary">
                                    <template v-slot:activator="{ on }">
                                        <v-icon :color="colors" v-html="icon_action" v-on="on" @click="abrirVentana(item.name)"></v-icon>

                                        <input type="file" :id="item.name" style="display: none;" :ref="item.name" @change="obtenerFile" accept=".pdf" />
                                    </template>
                                    <span>Subir Archivo</span>
                                </v-tooltip>
                            </v-btn>
                            </v-list-item-action>
                        </v-list-item>
                     </v-list>
                </v-col>
            </v-row>
            <v-row dense class="mt-10">
                <v-col cols="12">
                    <v-row dense>
                        <v-col cols="1" sm="1">
                            <v-checkbox dense color="primary" class="mt-1" v-model="autorizacion" />
                        </v-col>
                        <v-col cols="11" sm="11">
                            <v-textarea filled label="Autorización de Declaración" class="caption" v-html="parametros.parrafoAutorizacionPla"></v-textarea>
                            <!-- <p style="color: #000" class="caption" v-html="parametros.parrafoAutorizacionPla"></p> -->
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" class="text-right mt-3 mb-3">
                    <v-btn outlined rounded color="danger" class="mr-1" @click="previous('objDocu',listArchivos)">Anterior</v-btn>
                    <v-btn rounded dark color="primary" @click="validar" :disabled="disabled">Guardar</v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-form>
</template>

<script>
    export default {
        name: 'StepperIngresoDocumentoComponent',
        props: {
            cargar: {
                type: Boolean,
                default: false
            },
            objForm: {
                type: Object,
                default: {}
            },
            parametros: {
                type: Object,
                default: {}
            },
        },
        inject: ['previous','next','insertarActualizar'],
        data: () => ({
            autorizacion: false,
            numDividir: 1000000,
            totalFiles: 0,
            icon_action: 'cloud_upload',
            colors: "grey lighten-1",
            listArchivos: {},
            disabled: false
        }),
        watch:{
            cargar(val){
                if(val && _.size(this.listArchivos) == 0){
                    this.listArchivos = _.clone(this.objForm);
                    this.onListarCatalogoDocumentos('L');
                }
            }
        },
        methods:{
            onListarCatalogoDocumentos(event){
                if(!_.isUndefined(event)){
                    var error = 'E';
                    var objeto = {opcion: 'L', idTipoDocumento: this.parametros.idTipoDocumentoPlaCliente};
                    return axios.post(`${BASE_URI}administrador/documento/listar`,objeto)
                                .then((r) => {
                                    if (_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                    if (_.size(_.get(r,['data','data'],[])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }                                
                                        var l = _.filter(r.data.data,(v) =>{ return !_.includes(_.toLower(v.documento),'formulario') });
                                         _.forEach(l, (v,k) =>{
                                            var id = _.camelCase(v['documento']);
                                            this.$set(this.listArchivos,id,{
                                                'id'        : v['idDocumento'],
                                                'name'      : id,
                                                'title'     : v['documento'] ,
                                                'nameFile'  : v['nombreArchivo'],
                                                'subtitle'  : v['nombreArchivo'],
                                                'icon'      : 'folder',
                                                'iconClass' : 'grey lighten-1 white--text',
                                            });
                                        });
                                    return r;
                                })
                                .catch((e)=>{
                                    mensajesAlerta(e, error);
                                    return e;
                                });
                }
            },
            validar(){
                try {
                    if(!this.$refs.form_documentos.validate()) throw mensajeEstandar.faltaArchivos;
                    if(this.totalFiles < _.size(this.listArchivos)) throw mensajeEstandar.faltaArchivos;
                    if(!this.autorizacion) throw mensajeEstandar.faltaAutorizacion;
                    if(this.disabled) throw 'Petición en proceso, por favor espere.';

                        this.disabled = true;
                        return new Promise((resolve,reject)=>{
                            var l = [];
                            _.forEach(this.listArchivos,(v,k) => {
                                l.push({ id: v.id,name: v.nameFile, base: v.base });
                            });

                            this.next('listDocumentos',l,false);
                            return resolve(true);
                        })
                        .then((r) =>{
                            if(!r) throw mensajeEstandar.faltaArchivos;
                                return this.insertarActualizar();
                        })
                        .then((r)=>{
                            if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                        })
                        .catch((ex) => {
                            mensajesAlerta(ex,'I');
                            this.disabled = false;
                        });

                } catch (e) {
                    mensajesAlerta(e,'I');
                }
            },
            abrirVentana (p) {
                this.$refs[p][0].click()
            },
            obtenerFile(e){
                var obj = e.target;
                if (obj.files.length > 0) {
                    if(obj.files[0].size < this.parametros.taMaxArchivo){

                        this.listArchivos[obj.id].base  = obj.files[0].name;
                        this.listArchivos[obj.id].subtitle  = obj.files[0].name;
                        this.listArchivos[obj.id].iconClass = 'indigo lighten-2 white--text';   
                        var fr = new FileReader ()
                            fr.readAsDataURL(obj.files[0]);
                            fr.addEventListener('load', () => {
                                this.listArchivos[obj.id].base = fr.result;
                                this.$forceUpdate();
                            })
                        ++this.totalFiles;
                    }else
                        mensajesAlerta(mensajeEstandar.taMaximoArchivoPdf,'I');
                }else{
                    this.listArchivos[obj.id].base = '';
                    this.listArchivos[obj.id].subtitle  = '';
                    this.listArchivos[obj.id].iconClass = 'grey lighten-1 white--text';
                    --this.totalFiles;
                }
            }
        }
    }
</script>

<style>

</style>